// https://qiita.com/syobochim/items/120109315f671918f28d
export const prevent = (self = "form") => {
  const preventElement = $(self + " button");
  preventElement.prop("disabled", true);
  setTimeout(function () {
    preventElement.prop("disabled", false);
  }, 10000);
};
